import { useEffect } from "react";
import { ContainerV2, H1, P, PaymentCodContainerV2, InfoV2 } from "../../Atoms";
import { Tracking } from "../../../services/Tracking";
import { maskMoney } from "../../../utils/masks";
import { usePixV2 } from "./usePixV2";

export const PixV2 = () => {
  const { stepIndicator, pagamento, acessarFatura } = usePixV2();

  useEffect(() => {
    Tracking.pageView("mapa:agendamento/pagamento/pix:pageview");
  }, []);

  return (
    <>
      <ContainerV2
        backButton={false}
        nextButton={{
          title: "Ver Fatura",
          onClick: acessarFatura,
        }}
      >
        {stepIndicator}
        <H1 className="mb-4 mt-8">Pagamento</H1>
        <P className="mb-8 text-[#666666]">
          Após a aprovação você irá definir a data e horário.
        </P>

        <div className="flex flex-col items-center gap-8">
          <img
            src={pagamento?.pix?.qrcode}
            alt="qrcode"
            className="h-[236px] w-[230px] rounded-[10px] border-2 border-solid border-[#20332f]"
          />

          <p className="font-['Mulish'] text-base font-bold text-black">
            Valor: {maskMoney((pagamento?.valorTotal ?? 0) / 100)}
          </p>

          <PaymentCodContainerV2 value={pagamento?.pix?.qrcodeText ?? ""} />
        </div>
      </ContainerV2>
      <InfoV2 required>
        A escolha de <strong>data</strong> e <strong>horário</strong> estarão
        disponíveis após a confirmação do pagamento.
      </InfoV2>
    </>
  );
};
